// Actions
import { AuthActions, AuthActionTypes } from '../_actions/auth.actions';
// Models
import { UserModel, BasicUserModel } from '../_models/user.model';

export interface AuthState {
  loggedIn: boolean;
  user: BasicUserModel;
  isUserLoaded: boolean;
  userId: string;
}

export const initialAuthState: AuthState = {
  loggedIn: false,
  user: undefined,
  isUserLoaded: false,
  userId: undefined
};

export function clearState(reducer) {
  return (state, action) => {
    if (action.type === AuthActionTypes.Logout) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export function authReducer(
  state = initialAuthState,
  action: AuthActions
): AuthState {
  switch (action.type) {
    case AuthActionTypes.Login: {
      return {
        loggedIn: true,
        user: undefined,
        isUserLoaded: false,
        userId: undefined
      };
    }
    case AuthActionTypes.Logout:
      return initialAuthState;

    case AuthActionTypes.UserLoaded: {
      const _user: BasicUserModel = action.payload.user;
      return {
        ...state,
        loggedIn: true,
        user: _user,
        isUserLoaded: true,
        userId: _user.publicId
      };
    }

    default:
      return state;
  }
}
